module.exports = __webpack_public_path__ + "img/Carrosseriereparateurin_MS_006.c8f48961.jpg";